// src/pages/OnboardingHrPage.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';

function OnboardingHrPage() {
  const [content, setContent] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    async function loadHrOnboarding() {
      try {
        const response = await axios.get('/onboarding', { withCredentials: true });
        setContent(response.data);
      } catch (err) {
        const msg = err.response?.data || 'Fehler beim Laden des HR-Onboardings';
        setError(msg);
      }
    }
    loadHrOnboarding();
  }, []);

  function handleGoToHrProfile() {
    navigate('/hr-profile');
  }

  if (error) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center p-6 text-white">
        <p className="text-red-500 text-lg">{typeof error === 'object' ? JSON.stringify(error) : error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6 text-white">
      {/* Logo */}
      <div className="mb-10">
       <Logo variant="wordmark" size="xxxl" />
      </div>

      {/* Titel */}
      <h2 className="text-3xl md:text-4xl font-bold mb-8">Onboarding für HR</h2>

      {/* Inhalt vom Backend */}
      {content && (
        <div
          className="bg-gray-800 p-6 rounded-2xl shadow-md mb-8 w-full max-w-2xl"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}

      {/* Button */}
      <button
        onClick={handleGoToHrProfile}
        className="w-full max-w-md bg-mentixxgreen hover:bg-green-400 text-black font-bold py-2 rounded-2xl transition"
      >
        Zum HR-Profil
      </button>
    </div>
  );
}

export default OnboardingHrPage;
